import { render, staticRenderFns } from "./MyPictureDetail.vue?vue&type=template&id=451b115e&scoped=true"
import script from "./MyPictureDetail.vue?vue&type=script&lang=js"
export * from "./MyPictureDetail.vue?vue&type=script&lang=js"
import style0 from "./MyPictureDetail.vue?vue&type=style&index=0&id=451b115e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b115e",
  null
  
)

export default component.exports